// Placeholder content for Rafael Porter — client will provide final copy later.

export const BRAND = {
  name: "Reproductive Reconciliation",
  wordmark: ["Reproductive", "Reconciliation"],
  tagline: "You are not alone. There is safe help, and a way forward.",
};

export const HERO = {
  eyebrow: "Support for survivors of reproductive coercion",
  lines: ["A safe place", "to choose", "life"],
  body:
    "This site exists for anyone who feels pressured, frightened, or alone in their reproductive choices. Whether someone is pushing you to end a pregnancy, to stay pregnant, or to become pregnant, sabotaging your birth control, or controlling your body through threats, money, or fear, that is reproductive coercion, and you don't have to face it alone. You have options, and you have people ready to stand with you.",
  primaryCta: "Find help now",
  secondaryCta: "Read our promise",
};

export const STORY = {
  eyebrow: "My Story",
  heading: "Two abortions, only weeks apart",
  intro:
    "In the summer of 2007, over the span of just a few weeks, I underwent two abortions in California. At the time I was in love, and when he proposed marriage instead of a baby, or his family wouldn't approve, I thought I hit the jackpot. I grew up without a lot of resources or a large, loving family. What could possibly go wrong? If I just did this one thing, I would get everything I ever wanted. But what soon followed was fallout from friends who recognized early on how unhealthy the relationship was for me. Sometimes your friends are wrong about a guy you're seeing, but from my experience, they usually are not.",
  restrainingOrder:
    "What began as two became several while I was married and under his financial and coercive control. Marriage is a beautiful institution, but harm is often overlooked simply because you are married. Reproductive coercion often starts small, but many women find themselves enduring more and more over time, believing that going along with it will make him love them, or stay. It doesn't.",
  timeline: [
    {
      date: "July 11–14, 2007",
      title: "First pregnancy confirmed & ended",
      body: "",
    },
    {
      date: "August 2, 2007",
      title: "A second procedure, weeks later",
      body: "",
    },
    {
      date: "Afterward",
      title: "Then came my first born",
      body: "",
    },
  ],
  natalia: {
    label: "About my first born",
    body:
      "My first born came after these two procedures. He attempted to coerce me to terminate that pregnancy as well, a child with the very same due date I should have been celebrating, not because of me, and not because of her, but because his family wouldn't pay. Often when a woman is dependent on a husband, and he is dependent on his family for finances, it creates an environment where she has no place to turn for help. That was my story, and it's why I speak for self-advocacy now, because sometimes, in this situation, no one is coming to help you.",
  },
  coercion: {
    label: "Why financial control is abuse",
    body:
      "When money becomes the reason a pregnancy \"has to\" end, when a partner's parents, or your own, hold funds over your body and your choices, that is financial control. It is coercion, and it is a recognized form of abuse. No family's checkbook should ever decide whether your child gets to live.",
  },
  reflection: {
    label: "Honoring them, and myself",
    body:
      "Although the children are not living today, I took responsibility and accountability, even when he wouldn't. I worked with birthworkers and honored them as my own through a memorial and funeral. There are many ways to honor yourself and the grief that lingers. Memorials, letters, and rituals of remembrance can all be part of finding peace and reclaiming your story.",
    image:
      "https://images.unsplash.com/photo-1549002942-c6af9c116f79?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwyfHxzdW4lMjByYXlzJTIwY2xvdWRzJTIwYmlyZHMlMjBmbHlpbmclMjBvdmVyJTIwb2NlYW4lMjBzZXJlbmV8ZW58MHx8fHwxNzg3MTU5MjEwfDA&ixlib=rb-4.1.0&q=85",
    linkLabel: "Visit the memorial",
    linkHref: "https://everloved.com/life-of/the-unborn-shaw/",
  },
};


export const REASSURANCE = [
  "You are not alone",
  "There is safe help available",
  "Your life matters",
  "You can choose life",
  "Help is one call away",
  "You are stronger than you know",
];

export const MANIFESTO = {
  eyebrow: "Our promise",
  heading: "Why This Site Exists",
  intro:
    "We believe every woman deserves to make her decision free from fear, pressure, and coercion. These are the promises we keep.",
  chapters: [
    {
      no: "01",
      title: "No one should be forced",
      body:
        "A choice made under threat is not a choice. If a partner, parent, or anyone else is pressuring you to end your pregnancy, that pressure is not okay, and it is not your fault.",
    },
    {
      no: "02",
      title: "Safety comes first",
      body:
        "Coercion can be part of a larger pattern of control or abuse. We connect you with people trained to help you stay safe, plan quietly, and find shelter when you need it.",
    },
    {
      no: "03",
      title: "Real, practical support",
      body:
        "Housing, financial help, counseling, medical care, and legal guidance. Choosing life should never mean choosing it alone. We help you find what you need to move forward.",
    },
    {
      no: "04",
      title: "You keep your dignity",
      body:
        "No judgment. No shame. No agenda but yours. We meet you where you are and walk with you at your pace, for as long as you need.",
    },
  ],
};

export const SAFETY = {
  eyebrow: "Getting to safety",
  heading: "If someone is pressuring you toward an abortion",
  intro:
    "Pressure and coercion around pregnancy can be a form of abuse. Trust your instincts. Here are quiet, practical steps you can take to protect yourself.",
  steps: [
    {
      title: "Recognize coercion",
      body:
        "Threats, ultimatums, controlling your money, isolating you from family, or forcing a decision are all warning signs. You have the right to say no.",
    },
    {
      title: "Reach out privately",
      body:
        "Use a phone he can't access, a trusted friend's device, or a library computer. Clear your browser history, or use the Quick Exit button on this page anytime.",
    },
    {
      title: "Make a quiet plan",
      body:
        "Keep essentials such as ID, cash, medications, and important documents somewhere safe. Know where you would go and who you would call if you needed to leave quickly.",
    },
    {
      title: "Ask for help",
      body:
        "Advocates can help you find emergency housing, protective orders, and confidential support. You do not have to explain or justify. Just call.",
    },
  ],
  note:
    "If you are in immediate danger, call 911. For confidential 24/7 support in San Francisco, use the real crisis and safety lines below.",
};

export const HOTLINES = [
  {
    name: "National Domestic Violence Hotline",
    number: "1-800-799-7233",
    href: "tel:18007997233",
    hint: "24/7 confidential support serving all of California. Text START to 88788.",
  },
  {
    name: "Sexual Assault Hotline",
    number: "1-800-656-4673",
    href: "tel:18006564673",
    hint: "RAINN's National Sexual Assault Hotline connects you to a local California provider.",
  },
  {
    name: "Reproductive Coercion & Abuse",
    number: "1-866-331-9474",
    href: "tel:18663319474",
    hint: "love is respect: help with reproductive coercion and relationship abuse. Text LOVEIS to 22522.",
  },
  {
    name: "24/7 Crisis & Suicide Line",
    number: "Call or text 988",
    href: "tel:988",
    hint: "988 Suicide & Crisis Lifeline: free, confidential support any time.",
  },
  {
    name: "Victim Connect Resource Center",
    number: "1-855-484-2846",
    href: "tel:18554842846",
    hint: "Referral help for victims of crime, including safety and legal options.",
  },
  {
    name: "California Resource Directory",
    number: "Dial 2-1-1",
    href: "tel:211",
    hint: "Confidential local directory of shelters, counseling, and services statewide.",
  },
];

export const DIRECTORY = {
  eyebrow: "Places that can help",
  heading: "Resources across California",
  intro:
    "Confidential 24/7 crisis, sexual assault, reproductive coercion, and domestic violence resources serving survivors across the state of California. If you are being pressured or are unsafe, these people can help right now.",
  centers: [
    {
      name: "National Domestic Violence Hotline",
      location: "Serving all of California",
      type: "Domestic Violence",
      body:
        "24/7 confidential crisis support, safety planning, and referrals. Call 1-800-799-7233 or text START to 88788.",
      image:
        "https://images.unsplash.com/photo-1573495804664-b1c0849525af?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwyfHx3b21hbiUyMGNvbWZvcnRpbmclMjBzdXBwb3J0aXZlJTIwY291bnNlbGluZ3xlbnwwfHx8fDE3ODY3NjY5OTJ8MA&ixlib=rb-4.1.0&q=85",
    },
    {
      name: "California Coalition Against Sexual Assault",
      location: "Statewide network, CA",
      type: "Sexual Assault",
      body:
        "CALCASA connects survivors to a statewide network of rape crisis centers and advocacy. Sexual Assault Hotline: 1-800-656-4673.",
      image:
        "https://images.unsplash.com/photo-1717497043712-e197abe15c28?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwxfHxwcmVnbmFuY3klMjBzdXBwb3J0JTIwY2VudGVyJTIwd2FybSUyMGludGVyaW9yfGVufDB8fHx8MTc4Njc2Njk5Mnww&ixlib=rb-4.1.0&q=85",
    },
    {
      name: "love is respect",
      location: "Serving all of California",
      type: "Reproductive Coercion",
      body:
        "Confidential help for reproductive coercion and relationship abuse. Call 1-866-331-9474 or text LOVEIS to 22522.",
      image:
        "https://images.unsplash.com/photo-1774612541935-14b5efc16511?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwzfHxwcmVnbmFuY3klMjBzdXBwb3J0JTIwY2VudGVyJTIwd2FybSUyMGludGVyaW9yfGVufDB8fHx8MTc4Njc2Njk5Mnww&ixlib=rb-4.1.0&q=85",
    },
    {
      name: "California Partnership to End Domestic Violence",
      location: "Statewide coalition, CA",
      type: "Advocacy Network",
      body:
        "CPEDV links survivors to local domestic violence programs and shelters throughout California.",
      image:
        "https://images.unsplash.com/photo-1784958676531-d019515a7d54?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHw0fHxzYWZlJTIwaG91c2UlMjB3YXJtJTIwbGlnaHR8ZW58MHx8fHwxNzg2NzY2OTMyfDA&ixlib=rb-4.1.0&q=85",
    },
    {
      name: "Victim Connect Resource Center",
      location: "Serving all of California",
      type: "Victim Services",
      body:
        "Referral help for victims of crime: safety, compensation, and legal options. Call 1-855-484-2846.",
      image:
        "https://images.unsplash.com/photo-1738441611332-93237a80f57b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwyfHxwcmVnbmFuY3klMjBzdXBwb3J0JTIwY2VudGVyJTIwd2FybSUyMGludGVyaW9yfGVufDB8fHx8MTc4Njc2Njk5Mnww&ixlib=rb-4.1.0&q=85",
    },
    {
      name: "988 Suicide & Crisis Lifeline",
      location: "Nationwide, 24/7",
      type: "Crisis Line",
      body:
        "Free, confidential support for people in distress. Call or text 988 any time, from anywhere in the U.S.",
      image:
        "https://images.unsplash.com/photo-1778276539528-1d1846658dd1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHw0fHxtb3RoZXIlMjBhbmQlMjBuZXdib3JuJTIwYmFieSUyMHRlbmRlcnxlbnwwfHx8fDE3ODY3NjY5OTJ8MA&ixlib=rb-4.1.0&q=85",
    },
  ],
};

export const RESOURCES = {
  eyebrow: "Read & learn",
  heading: "Guides & encouragement",
  intro: "Placeholder articles. Final content will be provided by Rafael Porter.",
  articles: [
    { tag: "Safety", title: "Knowing the signs of reproductive coercion", read: "5 min read" },
    { tag: "Support", title: "Questions to ask a pregnancy resource center", read: "4 min read" },
    { tag: "Hope", title: "Stories from women who chose life", read: "7 min read" },
    { tag: "Practical", title: "Financial and housing help, explained", read: "6 min read" },
  ],
};

export const BWR = {
  eyebrow: "Community organization",
  name: "Black Women Revolt Against Domestic Violence",
  short: "Black Women Revolt",
  crisisLine: "1-888-260-1498 Ext. 1",
  crisisHref: "tel:18882601498,1",
  intro:
    "At Black Women Revolt, they are committed to being transparent and community-centered in all that they do. The BWRADV Resource Center offers culturally sensitive support for Black women and their families in San Francisco.",
  notice:
    "Due to changes in city funding, case management services and their crisis line hours have been adjusted to Monday through Friday, 12:00 PM to 4:00 PM, now through June 30, 2026. Case management is by appointment only. They know how vital these services are, and this decision was not made lightly. Thank you for standing with them as they continue to support survivors in the ways they can.",
  dedicatedTo: [
    "Increasing awareness about the impact of intergenerational violence in the Black community.",
    "Removing barriers for Black women and their families — girls, boys, men, and LGBTQIA+ community members — who have experienced domestic abuse to access culturally sensitive resources.",
    "Providing a designated space with resources specifically for Black women and their families in San Francisco to help educate and heal as they recover from abuse.",
  ],
  services: [
    "Case Management",
    "Education & Training",
    "Legal Services",
    "Support Groups",
    "Youth Prevention Services",
  ],
  contact: {
    phone: "1.888.260.1498",
    phoneHref: "tel:18882601498",
    email: "info@blackwomenrevolt.org",
    address: "1485 Bayshore Blvd., Suite 227, Mail Box #122, San Francisco",
  },
};


export const REPRO = {
  eyebrow: "Know the signs",
  heading: "What is reproductive coercion?",
  lead:
    "Reproductive coercion is a form of intimate partner violence and power control where one person tries to control another person's reproductive choices. It includes lying about or sabotaging birth control, forcing a partner to become pregnant, or forcing them to have an abortion against their will.",
  signs: [
    {
      title: "Birth control sabotage",
      body: "Hiding, throwing away, or damaging birth control pills, patches, or condoms.",
    },
    {
      title: "Stealthing",
      body: "Removing a condom during sex without telling the other person.",
    },
    {
      title: "Pregnancy pressure",
      body: "Constantly guilting, threatening, or forcing a partner to get pregnant.",
    },
    {
      title: "Outcome control",
      body: "Pressuring or threatening a partner to have an abortion, or forbidding them from having one.",
    },
  ],
  effects: [
    "Strongly linked to physical domestic abuse and higher rates of unintended pregnancies.",
    "Can lead to severe anxiety, depression, and post-traumatic stress.",
    "Takes away a person's basic right to choose what happens to their own body.",
  ],
  hotline: {
    text:
      "If you or someone you know needs help or support, you can reach out confidentially to the National Domestic Violence Hotline.",
    call: "1-800-799-7233",
    callHref: "tel:18007997233",
    textLine: "Text START to 88788",
    textHref: "sms:88788",
  },
  legalLabel: "Recognized as abuse under the law",
  legal:
    "In 2022, California enacted Senate Bill 374, amending Family Code §6320(c)(5) to expressly recognize \"reproductive coercion,\" controlling another person's reproductive autonomy through force, threat of force, or intimidation, as a form of abuse under the Domestic Violence Prevention Act. Courts have long recognized the \"devastating psychological consequences\" of a coerced abortion (Planned Parenthood v. Casey, 1992) and described forced abortion as a \"permanent and continuing\" harm with \"irremediable and ongoing suffering\" (Qili Qu v. Gonzales, 2005). Coercion to abort is an \"impermissible intrusion\" on a constitutionally protected freedom of choice (Arnold v. Board of Education, 1989).",
  disclaimer:
    "This site shares survivor experience and publicly reported research and case law for awareness. It is not legal advice. If you need legal help, contact a licensed attorney or a domestic violence advocate.",
};

export const STATS = {
  eyebrow: "By the numbers",
  heading: "Why survivors don't always follow through, and why that isn't proof it didn't happen",
  intro:
    "Leaving, and staying gone, is rarely a single decision. Research on protective orders shows how common it is for survivors to withdraw or not renew them, and how often abuse continues afterward.",
  stats: [
    {
      value: "~60%",
      label: "reported re-abuse by the person named in their temporary restraining order, with psychological abuse the most common form.",
      source: "U.S. DOJ, Office of Justice Programs",
    },
    {
      value: "~63%",
      label: "of women do not follow through to obtain a one-year order; only about 37% secure a final order.",
      source: "Zoellner et al., Violence and Victims (2000)",
    },
    {
      value: "79.6%",
      label: "of protection orders were violated within the first five months of being issued.",
      source: "Kaci, J. Am. Acad. Psychiatry Law (2010)",
    },
    {
      value: "~40%",
      label: "of women who obtain a temporary restraining order never return to court to request a permanent one.",
      source: "Harrell & Smith; Holt et al.",
    },
  ],
};

export const FOOTER = {
  blurb:
    "A survivor-led resource hub raising awareness of reproductive coercion and connecting victims of sexual assault, reproductive coercion, and domestic violence across California with confidential help.",
  emergency: "In an emergency, call 911.",
};
